module.exports = require('./lib/index.js');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-csv/index.js
 ** module id = 317
 ** module chunks = 0
 **/